import { E_OFFICE_PREFIX_URL } from '../../e-office-layout/constants/config.e-office-layout'

export const DOCUMENT_SHORT_PREFIX_URL = '/document-in-out'
export const DOCUMENT_VIEW_HR_PREFIX_URL = `${E_OFFICE_PREFIX_URL}${DOCUMENT_SHORT_PREFIX_URL}`
